import { Box, Grid, Tab, Tabs } from "@mui/material";
import { Custom, Item, Page } from "components";
import { useApp, useTheme } from "contexts";
import { IPotluck } from "interfaces";
import { useEffect, useState } from "react";

type Props = {
  potlucks: IPotluck[];
  onDelete: (id: string) => void;
};

export const PotluckDashboard = ({ potlucks, onDelete }: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();

  const [currentTab, setCurrentTab] = useState<number>(0);

  const [past, setPast] = useState<IPotluck[]>([]);
  const [upcoming, setUpcoming] = useState<IPotluck[]>([]);

  useEffect(() => {
    const now = new Date();
    const past = potlucks.filter((item) => new Date(item.date) < now);
    const upcoming = potlucks.filter((item) => new Date(item.date) > now);
    setPast(past);
    setUpcoming(upcoming);
  }, [potlucks]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) =>
    setCurrentTab(newValue);

  return (
    <>
      <Custom.Tabs currentTab={currentTab} onChange={handleTabChange}>
        <Tab value={0} label={t.label.upcoming_events} />
        <Tab value={1} label={t.label.past_events} />
      </Custom.Tabs>
      <Custom.TabContent value={currentTab} index={0}>
        <Grid container spacing={theme.spacing.sm}>
          {upcoming.length > 0 ? (
            upcoming.map((item: IPotluck) => (
              <Grid key={item._id} item xs={12} sm={6} md={4} lg={3}>
                <Item.Potluck potluck={item} onDelete={onDelete} />
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Page.Placeholder>
                <Custom.Typography size={theme.font.sm}>
                  {t.message.placeholder.no_potluck}
                </Custom.Typography>
              </Page.Placeholder>
            </Grid>
          )}
        </Grid>
      </Custom.TabContent>
      <Custom.TabContent value={currentTab} index={1}>
        <Grid container spacing={theme.spacing.sm}>
          {past.length > 0 ? (
            past.map((item: IPotluck) => (
              <Grid key={item._id} item xs={12} sm={6} md={4} lg={3}>
                <Item.Potluck potluck={item} onDelete={onDelete} />
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Page.Placeholder>
                <Custom.Typography size={theme.font.sm}>
                  {t.message.placeholder.no_potluck}
                </Custom.Typography>
              </Page.Placeholder>
            </Grid>
          )}
        </Grid>
      </Custom.TabContent>
    </>
  );
};
